import React from "react";
import { useTranslation } from "react-i18next";
import Contact from "../Home/Contact";
import Neo from "../../Assets/Drones/neoinfo.webp";
import MavicMini from "../../Assets/Drones/mini5proinfo.webp";
import Freestyle from "../../Assets/Drones/fpvh.webp";
import Pavo from "../../Assets/Drones/pavo.webp";
import Sony from "../../Assets/Drones/sony.webp";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import Seoimg from "../../Assets/drones.webp";

import { FaBalanceScale, FaClock, FaRocket, FaSignal, FaVideo } from "react-icons/fa";

const Drones = () => {
   const { t, i18n } = useTranslation();
   const basePath = i18n.language === "en" ? "/en" : "";

      const location = useLocation();
      const selectedLanguage = location.pathname.startsWith("/en")
         ? "en"
         : "es";

   const stabilizedDrones = [
      {
         name: t("drones_content.mavic_mini_n"),
         image: MavicMini,
         desc: t("drones_content.mavic_mini_desc"),
         time: t("drones_content.mavic_mini_ft"),
         quality: t("drones_content.mavic_mini_q"),
         distance: t("drones_content.mavic_mini_d"),
         speed: t("drones_content.mavic_mini_v"),
         weight: t("drones_content.mavic_mini_w"),
      },
      {
         name: t("drones_content.neo_n"),
         image: Neo,
         desc: t("drones_content.neo_desc"),
         time: t("drones_content.neo_ft"),
         quality: t("drones_content.neo_q"),
         distance: t("drones_content.neo_d"),
         speed: t("drones_content.neo_v"),
         weight: t("drones_content.neo_w"),
      },
   ];

   const fpvDrones = [
      {
         name: t("drones_content.tbp_n"),
         image: Freestyle,
         desc: t("drones_content.tbp_desc"),
         time: t("drones_content.tbp_ft"),
         quality: t("drones_content.tbp_q"),
         distance: t("drones_content.tbp_d"),
         speed: t("drones_content.tbp_v"),
         weight: t("drones_content.tbp_w"),
      },
      {
         name: t("drones_content.pavo_n"),
         image: Pavo,
         desc: t("drones_content.pavo_desc"),
         time: t("drones_content.pavo_ft"),
         quality: t("drones_content.pavo_q"),
         distance: t("drones_content.pavo_d"),
         speed: t("drones_content.pavo_v"),
         weight: t("drones_content.pavo_w"),
      },
   ];

   const cameras = [
      {
         name: t("drones_content.sony_n"),
         image: Sony,
         desc: t("drones_content.sony_desc"),
         time: t("drones_content.sony_ft"),
         quality: t("drones_content.sony_q"),
         distance: t("drones_content.sony_d"),
         speed: t("drones_content.sony_v"),
         weight: t("drones_content.sony_w"),
      },
   ];

   const seoTranslations = {
      es: {
         title: "Flota de Drones | Joan Company",
         description:
            "Descubre mi flota de drones profesionales para filmación aérea y grabaciones FPV. Equipos versátiles para cualquier proyecto.",
         keywords:
            "drones, fpv drones, drones estabilizados, filmación con drones, fotografía aérea, videografía aérea, servicios con drones, drones para inmobiliarias, drones para eventos, drones para inspecciones técnicas",
         canonical: "https://www.joancompany.es/drones",
      },
      en: {
         title: "Drone Fleet and FPV Drones | Joan Company",
         description:
            "Discover my fleet of professional drones for aerial filming and FPV recordings. Versatile equipment for any your projects.",
         keywords:
            "drones, fpv drones, stabilized drones, drone filming, aerial photography, aerial videography, drone services, drones for real estate, drones for events, drones for technical inspections",
         canonical: "https://www.joancompany.es/en/drones",
      },
      };
   
   return (
      <div className="policy-conditions" id="drones">
         <Helmet>
            <title key="title">{seoTranslations[selectedLanguage].title}</title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link
               rel="canonical"
               href={seoTranslations[selectedLanguage].canonical}
            />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content={seoTranslations[selectedLanguage].title}
            />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].description}
            />
            <link rel="image_src" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/drones"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/drones"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <div className="policy-conditions-container">
            <h1>{t("drones")}</h1>
            <h2>{t("drones_info")}</h2>
         </div>
         <div className="page-breadcrumb">
            <Link to={`${basePath}/`} title="Home">
               {t("home")}
            </Link>
            <span>/</span>
            <span>{t("drones")}</span>
         </div>
         <div className="drones-info-container">
            <div className="parallax" id="stabilized-drones">
               <div className="drones-stabilized">
                  <h3>{t("drones_stabilized")}</h3>
                  <p>{t("drones_stabilized_info")}</p>
                  <hr />
                  <div className="drones-stabilized-container">
                     {stabilizedDrones.map((drone, index) => (
                        <div key={index} className="drone-stabilized">
                           <div className="drone-img">
                              <img
                                 src={drone.image}
                                 alt={drone.name}
                                 title={drone.name}
                                 loading="lazy"
                                 style={{
                                    display: "block",
                                 }}
                              />
                           </div>
                           <h4>{drone.name}</h4>
                           <p>{drone.desc}</p>
                           <div className="drone-stabilized-info">
                              <span>
                                 <FaClock /> {drone.time}
                              </span>
                              <span>
                                 <FaVideo /> {drone.quality}
                              </span>
                              <span>
                                 <FaSignal /> {drone.distance}
                              </span>
                              <span>
                                 <FaRocket /> {drone.speed}
                              </span>
                              <span>
                                 <FaBalanceScale /> {drone.weight}
                              </span>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
            <div className="parallax" id="fpv-drones">
               <div
                  className="drones-fpv"
                  data-aos="fade-up"
                  data-aos-duration="2000"
               >
                  <h3>{t("drones_fpv")}</h3>
                  <p>{t("drones_fpv_info")}</p>
                  <hr />
                  <div className="drones-fpv-container">
                     {fpvDrones.map((drone, index) => (
                        <div key={index} className="drone-fpv">
                           <div className="drone-img">
                              <img
                                 src={drone.image}
                                 alt={drone.name}
                                 title={drone.name}
                                 loading="lazy"
                                 style={{
                                    display: "block",
                                 }}
                              />
                           </div>
                           <h4>{drone.name}</h4>
                           <p>{drone.desc}</p>
                           <div className="drone-fpv-info">
                              <span>
                                 <FaClock /> {drone.time}
                              </span>
                              <span>
                                 <FaVideo /> {drone.quality}
                              </span>
                              <span>
                                 <FaSignal /> {drone.distance}
                              </span>
                              <span>
                                 <FaRocket /> {drone.speed}
                              </span>
                              <span>
                                 <FaBalanceScale /> {drone.weight}
                              </span>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
               <div className="parallax" id="cameras">
                  <div
                     className="drones-fpvracing"
                     data-aos="fade-up"
                     data-aos-duration="2000"
                  >
                     <h3>{t("drones_cameras")}</h3>
                     <p>{t("drones_cameras_info")}</p>
                     <hr />
                     <div className="drones-fpvracing-container">
                        {cameras.map((drone, index) => (
                           <div key={index} className="drone-fpvracing">
                              <div className="drone-img">
                                 <img
                                    src={drone.image}
                                    alt={drone.name}
                                    title={drone.name}
                                    loading="lazy"
                                    style={{
                                       display: "block",
                                    }}
                                 />
                              </div>
                              <h4>{drone.name}</h4>
                              <p>{drone.desc}</p>
                              <div className="drone-fpvracing-info">
                                 <span>{drone.time}</span>
                                 <span>{drone.quality}</span>
                                 <span>{drone.distance}</span>
                                 <span>{drone.speed}</span>
                                 <span>{drone.weight}</span>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <Contact />
      </div>
   );
};

export default Drones;
